import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import JobCard from "./JobCard";
import RecallTable from "./RecallTable";
import Skeleton from "@mui/material/Skeleton";
import JobPricesDashboard from "./JobPricesDashboard";

const styles = {
    card: {
        maxWidth: 345,
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: "cover",
    },
    searchbox: {
        backgroundColor: "rgba(255, 255, 255, 0.5)",
    },
    iconButton: {
        padding: "2px",
    },
    searchtext: {
        backgroundColor: "rgba(255, 255, 255, 0.5)",
    },
    recall_grid_container: {
        display: "flex",
        flexWrap: "wrap",
        marginTop: "8px",
    },
    jobCardSkeleton: {
        flex: 1,
        border: "1px solid white",
        margin: "15px",
        display: "flex",
        position: "relative",
        transition: " border .15s ease-in",
        flexDirection: "column",
    },
    jobTableSkeleton: {
        flex: 1,
        margin: "15px",
        display: "flex",
        position: "relative",
        flexDirection: "column",
    },
    no_job_message: {
        width: "100%",
        height: "100px",
        textAlign: "center",
        paddingTop: "40px",
        fontStyle: "italic",
        color: "grey",
        fontSize: "20px",
    },
};

function RecallQuotesLayout(props) {
    const user = useSelector((state) => state.app.user);
    const [updatingLazyLoading, setUpdatingLazyLoading] = React.useState(false);

    const pinnedJobs = user?.pinned_jobs ?? [];
    const {
        classes,
        searchFilter,
        businessCode,
        setLoading,
        noJobMessage,
        displayMode,
        jobs,
        containerMode,
        loading,
        dashData,
        dashLoading,
        dashDateRange,
        updatingLazyLoad,
    } = props;
    let rows = [];
    if (jobs !== undefined) rows = jobs;

    useEffect(() => {
        if (updatingLazyLoad) {
            setUpdatingLazyLoading(true);
        }
    }, [updatingLazyLoad]);

    useEffect(() => {
        if (!loading) {
            setUpdatingLazyLoading(loading);
        }
    }, [loading]);

    // Sorts all pinned jobs as start of array
    pinnedJobs.map((e) => rows.sort((x, y) => (x.id === e ? -1 : y.id === e ? 1 : 0)));

    // Create new rows with pinned parameter
    let newRows = [];
    if (rows && rows.length > 0)
        rows.forEach((e) => {
            if (pinnedJobs.includes(e.id)) {
                let val = { ...e, pinned: true };
                newRows.push(val);
            } else {
                newRows.push(e);
            }
        });

    if (loading && !updatingLazyLoading) {
        if (displayMode === "Table") {
            return (
                <div className={classes.jobTableSkeleton}>
                    <Skeleton variant="text" sx={{ fontSize: "2rem", marginTop: "-5px" }} />
                    <Skeleton height={800} variant="rectangular" />
                </div>
            );
        } else if (displayMode === "Grid") {
            return (
                <div className={classes.recall_grid_container}>
                    {[...Array(20)].map((e, i) => {
                        return (
                            <div className={classes.jobCardSkeleton}>
                                <Skeleton
                                    sx={{ minWidth: "300px", maxWidth: "500px" }}
                                    height={140}
                                    variant="rectangular"
                                />
                                <Skeleton variant="text" sx={{ fontSize: "2rem", marginTop: "-5px" }} />
                            </div>
                        );
                    })}
                </div>
            );
        }
    }

    if (dashLoading && displayMode === "Cash") {
        return (
            <div>
                <Skeleton sx={{ width: 1200, height: 50, margin: "20px auto 0" }} variant="text" />
                <Skeleton sx={{ width: 1200, height: 400, margin: "0 auto 20px" }} variant="rectangular" />
            </div>
        );
    }

    return (
        <>
            {displayMode === "Table" ? (
                <RecallTable
                    searchFilter={searchFilter}
                    businessCode={businessCode}
                    setLoading={setLoading}
                    jobs={newRows}
                    containerMode={containerMode}
                    noJobMessage={noJobMessage}
                />
            ) : displayMode === "Grid" ? (
                <div className={classes.recall_grid_container}>
                    {newRows &&
                        newRows.map &&
                        newRows.map((row, index) => {
                            if (searchFilter && !JSON.stringify(row).toUpperCase().includes(searchFilter.toUpperCase()))
                                return null;

                            return (
                                <JobCard
                                    key={row.id + index}
                                    row={row}
                                    businessCode={businessCode}
                                    setLoading={setLoading}
                                    containerMode={containerMode}
                                />
                            );
                        })}
                    {noJobMessage && rows && rows.length === 0 && (
                        <div className={classes.no_job_message}>{noJobMessage}</div>
                    )}
                </div>
            ) : (
                <JobPricesDashboard
                    tableData={dashData}
                    loading={dashLoading}
                    businessCode={businessCode}
                    containerMode={containerMode}
                    dateRange={dashDateRange}
                />
            )}
        </>
    );
}

export default withStyles(styles)(RecallQuotesLayout);
